module.exports = __webpack_public_path__ + "static/media/Send_Message_Icon@3x.54a39182.png";